import { inject, Injectable, Injector } from '@angular/core';

import { createProviderToken, provide } from '@core/common-legacy';
import { HttpApiService } from '@core/http-legacy';
import { type HttpApiRequestOptions, HttpRequestData } from '@core/http-types';
import { TellentAdminRequestData } from '@core/tellent-http-legacy';

@Injectable()
export class TellentViewsRequestData extends TellentAdminRequestData {
  public buildUrl(path: string, requestOptions: HttpApiRequestOptions): string {
    return `${this.config.tellentApiUrl}${
      requestOptions.skipCompany ? '' : '/views/org/' + this.orgGuid
    }${path.replace('/views', '')}`;
  }
}

export const { inject: injectTellentViewsHttp } = createProviderToken('TellentIntelligenceHttp')(
  false,
  {
    providedIn: 'root',
    factory: () =>
      Injector.create({
        providers: [
          provide(HttpApiService, { useClass: HttpApiService }),
          provide(HttpRequestData, { useClass: TellentViewsRequestData }),
        ],
        parent: inject(Injector),
      }).get(HttpApiService),
  },
);
